module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "phone-shadow mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "phone-model",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "phone-model-title"
  }, [_vm._v("绑定手机")]), _vm._v(" "), _c('div', {
    staticClass: "phone-model-det gray-light"
  }, [_vm._v("确保能顺利使用本系统，请先进行手机绑定，")]), _vm._v(" "), _c('div', {
    staticClass: "phone-model-from"
  }, [_c('span', {
    staticClass: "gray phone-front"
  }, [_vm._v("+86")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "maxlength": "11",
      "type": "number",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "phone-model-from phone-model-yz"
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "maxlength": "4",
      "type": "number",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.clockSecond > 0 ? "phone-model-inter" : "get-code",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
    '(' + _vm.clockSecond + 's)' : '获取验证码') + "\n            ")])], 1), _vm._v(" "), _c('van-button', {
    staticClass: "phone-submit-btn",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bindPhone($event)
      }
    }
  }, [_vm._v("立即绑定")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 0",
      "color": "#666"
    }
  }, [_vm._v("登录或注册代表您已同意本平台"), _c('a', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 338
        }
      }),
      expression: "{name:'NewsDetail',query:{id:338}}"
    }],
    staticStyle: {
      "color": "#1989fa"
    },
    attrs: {
      "href": "#nogo"
    }
  }, [_vm._v("《用户协议》")]), _vm._v("和"), _c('a', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsDetail',
        query: {
          id: 335
        }
      }),
      expression: "{name:'NewsDetail',query:{id:335}}"
    }],
    staticStyle: {
      "color": "#1989fa"
    },
    attrs: {
      "href": "#nogo"
    }
  }, [_vm._v("《隐私政策》")])])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-910a32ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginDialog.vue
// module id = 2543
// module chunks = 0